// SPDX-License-Identifier: BUSL-1.1

import { apiFetch } from './api-client';

export interface ApiKeyRow {
  id: string;
  name: string;
  role: string;
  actorId: string;
  actorType: string;
  organizationId: string | null;
  createdAt: string;
  revokedAt: string | null;
}

export interface CreateApiKeyInput {
  name: string;
  actorId: string;
  actorType: string;
  role: string;
}

export interface CreateKeyResponse {
  id: string;
  key: string;
  name: string;
  role: string;
}

export async function fetchApiKeys(): Promise<ApiKeyRow[]> {
  return apiFetch<ApiKeyRow[]>('/keys');
}

export async function createApiKey(input: CreateApiKeyInput): Promise<CreateKeyResponse> {
  return apiFetch<CreateKeyResponse>('/keys', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function revokeApiKey(keyId: string): Promise<void> {
  await apiFetch<{ id: string; revoked: boolean }>(`/keys/${keyId}`, {
    method: 'DELETE',
  });
}
